import { createSelector } from 'reselect';

const getSettingsState = (state) => state.settings;

export const settingsSelector = createSelector([getSettingsState], (state) => {
  const { isLoadingConfig, mainConfig, errorConfig } = state;

  return {
    isLoadingConfig,
    mainConfig,
    errorConfig,
  };
});
